import { FormSection } from "components/MainSectionTemplate/types";
import CompanyModalPicker from "components/Picker/CompanyPicker/CompanyModalPicker";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import React from "react";
import ReadonlyCompany from "show/detail/components/ReadonlyCompany";
import ReadonlyContact from "show/detail/components/ReadonlyContact";
import { fetchFullContact } from "show/detail/utils";
import { getInstructionForInternal, ShowFieldMetaData, ShowFormState } from "shared/utils/fieldsHelper/showFields";

export const hotelSection = (
  show: server.dto.Show,
  showInfo: ShowFormState,
  hotelContact: server.dto.Contact,
  isExternal: boolean,
  fieldMetaData: ShowFieldMetaData,
  isSidebar: boolean
): FormSection => {
  const isInternalUser = !isExternal;

  const section: FormSection = {
    type: "regular",
    key: "showHotelSection",
    title: site.currentEnvironment.functionGroups.hotel.singular,
    hidden: !site.currentEnvironment.functionGroups.hotel.enabled,
    fields: [{
      ...fieldMetaData.hotelCompany.fields(),
      key: "hotel",
      label: site.currentEnvironment.functionGroups.hotel.singular,
      render: () => <ReadonlyCompany company={showInfo.hotel} displayAs="hotel" displayTooltip={isInternalUser} />,
      inPageEdit: {
        hoverEdit: true,
        canRemove: true,
        initialValue: showInfo.hotel,
        fullWidth: true,
        render: ({ onChange, cancel, value }) => (
          <div className="main-section-template-fields-padding">
            <CompanyModalPicker
              modalTitle={site.currentEnvironment.functionGroups.hotel.singular}
              addressType="regular"
              inPageEditing={{ onChange, cancel, hasValue: Boolean(value) }}
              canCreateNew={!isSidebar && site.permissions.addressBook.canCreate}
              afterCreate={isSidebar ? "goBack" : "closeSidebar"}
            />
          </div>
        ),
        type: "custom",
        submitChange: (value: server.dto.CompanySmall) =>
          window.CoreApi.Show.UpdateForInternalEnvironment(
            getInstructionForInternal(show.showId, showInfo, {
              hotelCompanyId: value?.companyId ?? null,
              hotelContactId: null,
            })
          )
      }
    }, {
      ...fieldMetaData.hotelContact.fields(),
      key: "hotelContact",
      label: RESX.Contact.resxContact,
      render: () => <ReadonlyContact contact={hotelContact} displayDetails displayPreview={isInternalUser} />,
      inPageEdit: {
        initialValue: hotelContact,
        fullWidth: true,
        hoverEdit: true,
        canRemove: true,
        render: ({ onChange, cancel, value }) => (
          <div className="main-section-template-fields-padding">
            <ContactModalPicker
              inPageEditing={{
                onChange: async (picked: server.dto.ContactSmallV2, submit: boolean) => {
                  const full = await fetchFullContact(picked);
                  onChange(full, submit);
                },
                cancel,
                hasValue: Boolean(value),
              }}
              fromCompanyId={showInfo.hotel?.companyId}
              canCreateNew={!isSidebar && site.permissions.addressBook.canCreate}
              afterCreate={isSidebar ? "goBack" : "closeSidebar"}
            />
          </div>
        ),
        type: "custom",
        submitChange: (value: server.dto.Contact) =>
          window.CoreApi.Show.UpdateForInternalEnvironment(
            getInstructionForInternal(show.showId, showInfo, { hotelContactId: value?.contactId ?? null })
          )
      }
    }]
  };

  return section;
};
